import React, { Component } from "react";
import styled, { css } from "styled-components";

import Input from "./Input";
import Button from "./Button";
import ErrorText from "./ErrorText";
import { PhoneIcon, MailIcon } from "./Icons";

const Overlay = styled.div`
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  z-index: 10000;
`;

const Popup = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 500px;
  padding: 10px 35px 25px;
  border-radius: 5px;
  font-size: ${({theme}) => theme.locale === "ar" ? theme.minFontSize : "12px"};
  text-align: center;
  background: #f6f6f6;
  box-shadow: 0 0 17px 0px rgba(0, 0, 0, 1);
`;

const Header = styled.h2`
  font-size: 22px;
  font-weight: 400;
  line-height: 1.2;
  padding: 0 11px;
  color: #343434;
  text-align: center;
  margin: 20px 0;
  @media (max-width: 959px) {
    font-size: 19px;
  }
  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const InputContainer = styled.div`
  width: 90%;
  max-width: 350px;
  margin: 0 auto 20px;
`;

const ButtonContainer = styled.div`
  display: inline-block;
  min-width: 100px;
  text-align: center;
`;

const Close = styled.div`
  position: absolute;
  top: 18px;
  right: 18px;
  width: 16px;
  height: 16px;
  background-size: cover;
  cursor: pointer;
  :before {
    position: absolute;
    top: -1px;
    left: 50%;
    transform: translateX(-50%) rotate(45deg);
    transform-origin: 100%;
    content: "";
    width: 0px;
    height: 20px;
    border-left: 2px solid #a0a7b2;
    transition: all 0.3s ease;
  }
  :after {
    position: absolute;
    top: -1px;
    left: 50%;
    transform: translateX(-50%) rotate(-45deg);
    transform-origin: 0%;
    content: "";
    width: 0px;
    height: 20px;
    border-left: 2px solid #a0a7b2;
    transition: all 0.3s ease;
  }
  :hover {
    :before {
      border-left-color: #60a31c;
    }
    :after {
      border-left-color: #60a31c;
    }
  }
`;

const Notification = styled.div`
  ${props =>
    props.type === "error" &&
    css`
    margin-top: 5px;
    text-align: center;
  `}

  ${props =>
    props.type === "success" &&
    css`
    font-size: 16px;
    line-height: 1.2;
  `}
`;

class ReferralsPopup extends Component {
  state = {
    value: ""
  };

  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onChange(value) {
    this.setState({
      value: value.trim()
    });
  }

  onSubmit() {
    if (typeof this.props.onSubmit === "function" && this.state.value) {
      this.props.onSubmit(this.state.value);
    }
  }

  render() {
    const { title, submitTitle, type, sending, onClose } = this.props;

    return (
      <Overlay>
        <Popup>
          <Close onClick={onClose} />
          <Header>
            {title}:
          </Header>
          <InputContainer>
            <Input
              type={type}
              id="popup-input"
              label={title}
              onChange={this.onChange}
              value={this.state.value}
              desktop
              focus={true}
              Icon={(type === "email" && MailIcon) || PhoneIcon}
            />
          </InputContainer>
          <ButtonContainer>
            {!this.props.requestSuccess &&
              <div>
                <Button
                  title={submitTitle}
                  onClick={this.onSubmit}
                  disabled={!this.state.value || sending}
                  showSpinner={sending}
                />
              </div>}
          </ButtonContainer>
          <Notification type={this.props.requestSuccess ? "success" : "error"}>
            {this.props.requestSuccess
              ? this.props.responseMessage
              : <ErrorText>
                  {this.props.responseMessage}
                </ErrorText>}
          </Notification>
        </Popup>
      </Overlay>
    );
  }
}

export default ReferralsPopup;



// WEBPACK FOOTER //
// ./src/components/ReferralsPopup.js